import { render, staticRenderFns } from "./main.vue?vue&type=template&id=575dacfb&scoped=true&"
var script = {}
import style0 from "./main.vue?vue&type=style&index=0&id=575dacfb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "575dacfb",
  null
  
)

export default component.exports